import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../../../store";
import { Loader } from "../../../../components/loader";
import "react-phone-number-input/style.css";
import "react-select/dist/react-select.css";
import "react-rangeslider/lib/index.css";
import { fetchSingleWooLocationPage, generateLocationPageContentBaseOnOpenAi, uploadHeroImage, updateWooLocationPage } from "../../../../actions/locations";
import { BreadCrumb } from "../../../../components/breadcrumb";
import states from "../data/states.json";
import stateData from "../data/data.json";
import _ from "lodash";

const $ = window.$;

const IMAGE_TYPE = {
 webp : "webp",
 png : "png"
};

const LOCATION_TYPE = {
  state : "state",
  city : "city"
};

const initialState = {
  editInfo: false,
  pageContent: {},
  post_title: ``,
  post_content: ``,
  loading: false,
  city: "",
  state: "none",
  stateName: null,
  post_url: "",
  post_meta_title: "",
  post_meta_description: "",
  location_all_puppies_title: "",
  location_all_puppies_description: "",
  location_all_puppies_transportation: "",
  location_hero_title_one: "",
  location_hero_title_two: "",
  location_hero_image_description: "",
  location_hero_image_webp: "",
  location_hero_image_png : "",
  location_hero_image_alt : "",
  isHeroWebpImageUploading: false,
  isHeroPngImageUploading: false,
  location_quiz_title: "",
  location_quiz_description: "",
  location_review_title: "",
  location_review_description: "",
  location_finance_title: "",
  location_finance_description: "",
  location_delivery_title: "",
  location_delivery_description: "",
  location_health_commitment_title: "",
  location_health_commitment_description: "", 
  location_core_team_title: "",
  location_core_team_description: "",
  location_contact_title: "",
  location_contact_description: "",
  editorState: null,
  step: 1,
  imageFile: null,
  locationStates: states,
  statesArray : [],
  citiesArray : [],
  locationPagePrompt : {},
  loading : false,
  loadingOpenAiContent : false,
};

class Datamodal extends React.Component {
  constructor(props) {
    super(props);

  }

  state = initialState;

  onEditorStateChange = editorState => this.setState({ editorState });


  changeVal = event => {
    let value = event.target.value;

    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  _onChange = (event) => {
   if(event && event.target && event.target.files && event.target.files.length >0 ){
    event.persist();
    this.setState({ imageFile: event.target.files[0] });
   } 
   
  }

  saveHeroImage = async (type) => {
    let _self = this;
    if(this.state.imageFile){
    if(type === IMAGE_TYPE.webp){     
      this.setState({  isHeroWebpImageUploading: true });
    }else{
      this.setState({ isHeroPngImageUploading: true });
    }
    let formData = new FormData();
    formData.append('file', this.state.imageFile);
    let result = await uploadHeroImage(type,formData);
    result.payload.then(resp => {  
      if( type === IMAGE_TYPE.webp ){
      _self.setState({ location_hero_image_webp : resp.data, imageFile : null, isHeroWebpImageUploading : false });
      }else{
        _self.setState({ location_hero_image_png : resp.data, imageFile : null, isHeroPngImageUploading : false  });
      }
      NotificationManager.success("Image Uploaded Successfully");
    });
   }else{
      NotificationManager.warning("Please select image first");
   }

  }

  locationUpdate = async () => {
    this.setState({ loading: true });
    let form_step_1 = this.state;
    let pageId = this.props.match.params.id;
    let data = {
      id : pageId,
      post_title : form_step_1.post_title,
      post_url : form_step_1.post_url,
      post_content : form_step_1.post_content,
      _yoast_wpseo_title : form_step_1.post_meta_title,
      _yoast_wpseo_metadesc : form_step_1.post_meta_description,
      location_hero_title_one : form_step_1.location_hero_title_one,
      location_hero_title_two : form_step_1.location_hero_title_two,
      location_hero_image_description : form_step_1.location_hero_image_description,
      location_hero_image_webp : form_step_1.location_hero_image_webp,
      location_hero_image_png : form_step_1.location_hero_image_png,
      location_hero_image_alt : form_step_1.location_hero_image_alt,
      location_all_puppies_title : form_step_1.location_all_puppies_title,
      location_all_puppies_description : form_step_1.location_all_puppies_description, 
      location_all_puppies_transportation : form_step_1.location_all_puppies_transportation,
      location_quiz_title : form_step_1.location_quiz_title,
      location_quiz_description : form_step_1.location_quiz_description,
      location_review_title : form_step_1.location_review_title,
      location_review_description : form_step_1.location_review_description,
      location_finance_title : form_step_1.location_finance_title,
      location_finance_description : form_step_1.location_finance_description,
      location_delivery_title : form_step_1.location_delivery_title,
      location_delivery_description : form_step_1.location_delivery_description,
      location_health_commitment_title : form_step_1.location_health_commitment_title,
      location_health_commitment_description : form_step_1.location_health_commitment_description,
      location_core_team_title : form_step_1.location_core_team_title,
      location_core_team_description : form_step_1.location_core_team_description,
      location_contact_title : form_step_1.location_contact_title,
      location_contact_description : form_step_1.location_contact_description,
    };
    if (!_.isEmpty(data)) {
      this.props.updateWooLocationPage(pageId, data);
   
    }else{
      NotificationManager.warning("Please check input details again.");
      this.setState({ loading: false });
    }
  };

  componentWillReceiveProps = (nextProps, prevProps) => {

    if(nextProps.data.wooLocationReducer.generatedLocationPageContents && this.props.data.wooLocationReducer.generatedLocationPageContents !== nextProps.data.wooLocationReducer.generatedLocationPageContents){   
      let generatedData = nextProps.data.wooLocationReducer.generatedLocationPageContents;
      this.setState({
        location_all_puppies_title : generatedData.AvailablePuppiesSection ? generatedData.AvailablePuppiesSection.Title : "",
        location_all_puppies_description : generatedData.AvailablePuppiesSection ? generatedData.AvailablePuppiesSection.SubtitleCTA : "",    

        location_quiz_title :  generatedData.AboutTheQuiz ? generatedData.AboutTheQuiz.Title : "",
        location_quiz_description : generatedData.AboutTheQuiz ? generatedData.AboutTheQuiz.SubtitleCTA : "", 

        location_review_title : generatedData.Reviews ? generatedData.Reviews.Title : "",
        location_review_description : generatedData.Reviews ? generatedData.Reviews.SubtitleCTA : "",

        location_finance_title : generatedData.PuppyFinancing ? generatedData.PuppyFinancing.Title : "",
        location_finance_description : generatedData.PuppyFinancing ? generatedData.PuppyFinancing.SubtitleCTA : "", 

        location_delivery_title : generatedData.PuppyDelivery ? generatedData.PuppyDelivery.Title : "",
        location_delivery_description : generatedData.PuppyDelivery ? generatedData.PuppyDelivery.SubtitleCTA : "",

        location_health_commitment_title :  generatedData.PuppyHealthcare ? generatedData.PuppyHealthcare.Title : "" ,
        location_health_commitment_description :  generatedData.PuppyHealthcare ? generatedData.PuppyHealthcare.SubtitleCTA : "",

        location_core_team_title :  generatedData.CoreTeam ? generatedData.CoreTeam.Title : "",
        location_core_team_description :  generatedData.CoreTeam ? generatedData.CoreTeam.SubtitleCTA : "",

        location_contact_title : generatedData.PuppyContactUs ? generatedData.PuppyContactUs.Title : "",
        location_contact_description : generatedData.PuppyContactUs ? generatedData.PuppyContactUs.SubtitleCTA : "",    
        
        loadingOpenAiContent : false,     
        
      });
      NotificationManager.success("Contents are created successfully");
    }

    if(nextProps.data.wooLocationReducer.wooSingleLocationPage && this.props.data.wooLocationReducer.wooSingleLocationPage !== nextProps.data.wooLocationReducer.wooSingleLocationPage){
      let webPageContent = nextProps.data.wooLocationReducer.wooSingleLocationPage;   
      // Filter city name and state name from post title
      const pattern = /in\s*([\w\s]+)(?:,\s*([\w]+))?/i;
      const match = webPageContent.post_title.match(pattern);
      let cityName,state,cityFinalName
      if (match) {
          cityName =  match[1].trim();
          state = match[2] ? match[2].trim() : cityName;
          cityFinalName = match[2] ? cityName : "";  
      }else{
        cityFinalName = null;
        state = null;
      } 
      if(state){
        let stateName = states.find(item => item.value == state );

        if(stateName){
          let statePrompt = stateData.find(state => state.name == stateName.name); 
    
          if(statePrompt && statePrompt.cities && statePrompt.cities[cityFinalName] ){    
            let cityPrompt = statePrompt.cities[cityFinalName];
            cityPrompt['name'] = `${cityFinalName},${this.state.state}`;     
            this.setState ( { locationPagePrompt : cityPrompt });
          }else{
            this.setState ( { locationPagePrompt : statePrompt });
          }
    
          this.setState({     
            pageContent : webPageContent.post_meta,
            pageUrl : webPageContent.guid,
            post_title : webPageContent.post_title,
            post_name : webPageContent.post_name,
            post_content : webPageContent.post_content,
            state : stateName.name,
            city : cityFinalName,
            step : 1,
            editInfo : false,
          });

        }else{
          NotificationManager.error("Page state prompt not found");
        }
      }else{
        NotificationManager.error("Page state not found");
      }
  

    
      
   
    } 

    if(nextProps.data.wooLocationReducer.updatedLocationPage && this.props.data.wooLocationReducer.updatedLocationPage !== nextProps.data.wooLocationReducer.updatedLocationPage){  
   
      NotificationManager.success("Contents are updated successfully");
      this.setState({ loading : false });
      this.props.fetchSingleWooLocationPage(this.props.match.params.id);
    }

    if(nextProps.data.wooLocationReducer.generatedLocationPageContentsError && this.props.data.wooLocationReducer.generatedLocationPageContentsError !== nextProps.data.wooLocationReducer.generatedLocationPageContentsError){
      this.setState({ loadingOpenAiContent : false });
      if(nextProps.suggestedPetsNamesError && nextProps.suggestedPetsNamesError.message){
        NotificationManager.error(nextProps.suggestedPetsNamesError.message); 
      }else{
        NotificationManager.error("An error occurred while generating the contents"); 
      }
    }

    if(nextProps.data.wooLocationReducer.updatedLocationPageError && this.props.data.wooLocationReducer.updatedLocationPageError !== nextProps.data.wooLocationReducer.updatedLocationPageError){     
      NotificationManager.error("An error occurred while updating the location page"); 
      this.setState({ loading : false });
     
    }

  };

  componentDidMount = () => {  

    this.props.fetchSingleWooLocationPage(this.props.match.params.id);
  };

  items = [
    { title: "Location Pages", to: "/location/pages" },
    { title: "New Location Page", to: "/location/pages/add" }
  ];

  goBack(self) {
    self.setState({ step: (this.state.step - 1) });
  }

  goNext(self) {    
    if(self.state.state !== "none"){  
      self.setState({ step: (this.state.step + 1) });
    }else{
      NotificationManager.warning("Please select the state");
    }   
  }

  generateContent = () => {
    if(this.state.state && this.state.state !== 'none' ){
      if(this.state.city){    
        this.props.generateLocationPageContentBaseOnOpenAi(this.state.locationPagePrompt);
      }else{      
        let locationData = this.state.locationPagePrompt;
        delete locationData.cities;     
        this.props.generateLocationPageContentBaseOnOpenAi(locationData); 
      }
     this.setState({ loadingOpenAiContent : true });
    }else{
      NotificationManager.warning("Please select the state.");
    }
  }

  editInfo = () => {
    if (!this.state.editInfo) {      
      // this.setState({
      //   editInfo: true,   
      // });         
      this.setState({
          editInfo: true,   

          post_title : this.state.post_title, 
         // post_name : this.state.post_name,   
          post_url : this.state.post_name,  
          post_meta_title : this.state.pageContent._yoast_wpseo_title &&  this.state.pageContent._yoast_wpseo_title.length > 0 ?  this.state.pageContent._yoast_wpseo_title[0]: "", 
          post_meta_description : this.state.pageContent._yoast_wpseo_metadesc &&  this.state.pageContent._yoast_wpseo_metadesc.length > 0 ?  this.state.pageContent._yoast_wpseo_metadesc[0]: "", 
          
          location_hero_image_webp : this.state.pageContent.location_hero_image_webp &&  this.state.pageContent.location_hero_image_webp.length > 0 ?  this.state.pageContent.location_hero_image_webp[0]: "",
          location_hero_image_png : this.state.pageContent.location_hero_image_png && this.state.pageContent.location_hero_image_png.length > 0 ?  this.state.pageContent.location_hero_image_png[0]: "",
          location_hero_title_one : this.state.pageContent.location_hero_title_one &&  this.state.pageContent.location_hero_title_one.length > 0 ?  this.state.pageContent.location_hero_title_one[0]: "",
          location_hero_title_two : this.state.pageContent.location_hero_title_two &&  this.state.pageContent.location_hero_title_two.length > 0 ?  this.state.pageContent.location_hero_title_two[0]: "",
          location_hero_image_description : this.state.pageContent.location_hero_image_description &&  this.state.pageContent.location_hero_image_description.length > 0 ?  this.state.pageContent.location_hero_image_description[0]: "",
          location_hero_image_alt : this.state.pageContent.location_hero_image_alt &&  this.state.pageContent.location_hero_image_alt.length > 0 ?  this.state.pageContent.location_hero_image_alt[0]: "",
          
          location_all_puppies_title : this.state.pageContent.location_all_puppies_title &&  this.state.pageContent.location_all_puppies_title.length > 0 ?  this.state.pageContent.location_all_puppies_title[0]: "" ,
          location_all_puppies_description : this.state.pageContent.location_all_puppies_description &&  this.state.pageContent.location_all_puppies_description.length > 0 ?  this.state.pageContent.location_all_puppies_description[0]: "",    
          location_all_puppies_transportation : this.state.pageContent.location_all_puppies_transportation &&  this.state.pageContent.location_all_puppies_transportation.length > 0 ?  this.state.pageContent.location_all_puppies_transportation[0]: "", 

          location_quiz_title :  this.state.pageContent.location_quiz_title &&  this.state.pageContent.location_quiz_title.length > 0 ?  this.state.pageContent.location_quiz_title[0]: "" ,
          location_quiz_description : this.state.pageContent.location_quiz_description &&  this.state.pageContent.location_quiz_description.length > 0 ?  this.state.pageContent.location_quiz_description[0]: "", 
  
          location_review_title : this.state.pageContent.location_review_title &&  this.state.pageContent.location_review_title.length > 0 ?  this.state.pageContent.location_review_title[0]: "",
          location_review_description : this.state.pageContent.location_review_description &&  this.state.pageContent.location_review_description.length > 0 ?  this.state.pageContent.location_review_description[0]: "",
  
          location_finance_title : this.state.pageContent.location_finance_title &&  this.state.pageContent.location_finance_title.length > 0 ?  this.state.pageContent.location_finance_title[0]: "",
          location_finance_description : this.state.pageContent.location_finance_description &&  this.state.pageContent.location_finance_description.length > 0 ?  this.state.pageContent.location_finance_description[0]: "", 
  
          location_delivery_title : this.state.pageContent.location_delivery_title &&  this.state.pageContent.location_delivery_title.length > 0 ?  this.state.pageContent.location_delivery_title[0]: "",
          location_delivery_description : this.state.pageContent.location_delivery_description &&  this.state.pageContent.location_delivery_description.length > 0 ?  this.state.pageContent.location_delivery_description[0]: "",
  
          location_health_commitment_title : this.state.pageContent.location_health_commitment_title &&  this.state.pageContent.location_health_commitment_title.length > 0 ?  this.state.pageContent.location_health_commitment_title[0]: "",
          location_health_commitment_description : this.state.pageContent.location_health_commitment_description &&  this.state.pageContent.location_health_commitment_description.length > 0 ?  this.state.pageContent.location_health_commitment_description[0]: "",
  
          location_core_team_title : this.state.pageContent.location_core_team_title &&  this.state.pageContent.location_core_team_title.length > 0 ?  this.state.pageContent.location_core_team_title[0]: "",
          location_core_team_description : this.state.pageContent.location_core_team_description &&  this.state.pageContent.location_core_team_description.length > 0 ?  this.state.pageContent.location_core_team_description[0]: "",
  
          location_contact_title : this.state.pageContent.location_contact_title &&  this.state.pageContent.location_contact_title.length > 0 ?  this.state.pageContent.location_contact_title[0]: "",
          location_contact_description : this.state.pageContent.location_contact_description &&  this.state.pageContent.location_contact_description.length > 0 ?  this.state.pageContent.location_contact_description[0]: "",  
          
              
          
        });


    } else {
      this.cancelEditInfo();
    }
  };

  cancelEditInfo = () => {
    this.setState({ editInfo: false });
  };

  render() {
    const {
      editInfo,
      pageContent,
      state,
      city,
      pageUrl,
      post_url,
      post_meta_title,
      post_meta_description,
      location_hero_title_one,
      location_hero_title_two,
      location_hero_image_description,
      location_hero_image_webp,
      location_hero_image_png,  
      location_hero_image_alt,
      location_all_puppies_title,
      location_all_puppies_description,
      location_all_puppies_transportation,
      location_quiz_title,
      location_quiz_description,   
      location_review_title,
      location_review_description,   
      location_finance_title,
      location_finance_description, 
      location_delivery_title,
      location_delivery_description,
      location_health_commitment_title,
      location_health_commitment_description,
      location_core_team_title,
      location_core_team_description,
      location_contact_title,
      location_contact_description,
      statesArray,
      citiesArray,
      isHeroWebpImageUploading,
      isHeroPngImageUploading,
      loading,
      loadingOpenAiContent,
      step
    } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--lg m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                         Edit Location Page                 
                      </h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">   
                    
                         { editInfo &&
                           <> 
                            {  !loadingOpenAiContent ?                                                     
                            <button
                              className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill btn-sm mr-2"
                              onClick={(e)=>{ this.generateContent()}}
                            >
                               Create Contents
                            </button>:  <Loader size={25} />
                            }
                            </>                                                         
                          }                        
                             
                         <button
                            onClick={() => this.editInfo()}
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air pl-2"
                          >
                            <i className="la la-edit"></i>
                            <span>Edit</span>
                          </button>
                  </div>
                </div>
                <div className="m-wizard m-wizard--1 m-wizard--success">
                  <div className="m-wizard__form">
                    <form
                      onSubmit={this.submit}
                      className="m-form m-form--label-align-left- m-form--state-"
                    >
                      <div className="m-portlet__body m-portlet__body_grey">
                        <div id={"form-step1"}>
                          <div className="row">
                            <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                              {step === 1 ?
                                <div className="m-form__section">                                                                    
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                       State:
                                    </label>
                                    <div className="col-lg-6">                        
                                      <span>
                                      {state ? state :""}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      City:
                                    </label>
                                    <div className="col-lg-6">                                
                                      {city ? city : ""}
                                    </div>
                                  </div>                     
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      URL:
                                    </label>
                                    <div className="col-lg-6">
                                      <span>                                    
                                        {pageUrl}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Meta Title:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={post_meta_title}
                                        name="post_meta_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                               
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>
                                       {pageContent._yoast_wpseo_title &&  pageContent._yoast_wpseo_title.length > 0 ?  pageContent._yoast_wpseo_title[0]: ""}
                                      </span>
                                    </div>
                                    }
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Meta Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="post_meta_description"
                                        onChange={this.changeVal}
                                        value={post_meta_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                       <div className="col-lg-6">
                                         <span>
                                         {pageContent._yoast_wpseo_metadesc &&  pageContent._yoast_wpseo_metadesc.length > 0 ?  pageContent._yoast_wpseo_metadesc[0]: ""}
                                         </span>
                                       </div>
                                     }
                                  </div>                      
                                                 
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                     Hero Image Title One:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_hero_title_one}
                                        name="location_hero_title_one"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                                 
                                    </div>:
                                      <div className="col-lg-6">
                                        <span>
                                          {pageContent.location_hero_title_one &&  pageContent.location_hero_title_one.length > 0 ?  pageContent.location_hero_title_one[0]: ""}  {pageContent.location_hero_title_one &&  pageContent.location_hero_title_one.length > 0 ?  pageContent.location_hero_title_one[0]: ""}
                                        </span>
                                      </div>    
                                    }                              
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                     Hero Image Title Two:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_hero_title_two}
                                        name="location_hero_title_two"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                                  
                                    </div>:
                                      <div className="col-lg-6">
                                        <span>
                                          {pageContent.location_hero_title_two &&  pageContent.location_hero_title_two.length > 0 ?  pageContent.location_hero_title_two[0]: ""}
                                        </span>
                                      </div>        
                                    }                          
                                  </div>
                          
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                     Hero Image Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_hero_image_description"
                                        onChange={this.changeVal}
                                        value={location_hero_image_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                      <div className="col-lg-6">
                                        <span>
                                          {pageContent.location_hero_image_description &&  pageContent.location_hero_image_description.length > 0 ?  pageContent.location_hero_image_description[0]: ""}
                                        </span>
                                      </div> 
                                     }
                                  </div> 
                         
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                     Upload WebP Hero Image:
                                    </label>
                                    { editInfo ?
                                    <>
                                    <div className="col-lg-4">
                                    <input 
                                      ref="file"
                                      type="file"
                                      accept="image/*" 
                                      name="imgSrc"
                                      onChange={this._onChange}
                                      
                                    />                             
                                    </div>
                                    <div className="col-lg-2">                       
                                     
                                      <a
                                       className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                       onClick={() => this.saveHeroImage('webp')}    
                                      >
                                         <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                                      </a>
                                    </div>
                                    {isHeroWebpImageUploading ?                                   
                                    <div className="col-lg-2">
                                      <div className="center-row">                                         
                                          <Loader size={25} />
                                      </div>
                                    </div>:null  }         
                             
                                  </>:
                                   <div>
                                      <img style={{maxWidth:"150px",maxHeight:"150px"}}
                                       src={ pageContent.location_hero_image_webp && pageContent.location_hero_image_webp.length > 0 ? pageContent.location_hero_image_webp[0] :"" }
                                       alt=""
                                      />   
                                  </div>
                                   }
                                   </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      WebP Hero Image:
                                    </label>                                
                                    <div className="col-lg-6" style={{overflow : 'hidden'}}>    
                                    {editInfo ?                            
                                      <input
                                        type="text"
                                        value={location_hero_image_webp}
                                        name="location_hero_image_webp"                                   
                                        className="form-control m-input"
                                        disabled
                                      />:
                                      <span >
                                          {pageContent.location_hero_image_webp &&  pageContent.location_hero_image_webp.length > 0 ?  pageContent.location_hero_image_webp[0]: ""}
                                      </span>
                                      }
                                    </div>                              
                           
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Upload PNG Hero Image:
                                    </label>
                                    {editInfo ?
                                    <>
                                    <div className="col-lg-4">
                                      <input 
                                        ref="file"
                                        type="file"
                                        accept="image/*" 
                                        name="imgSrc"
                                        onChange={this._onChange}                                      
                                      />                             
                                    </div>
                                    <div className="col-lg-2">                                      
                                      <a
                                       className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                       onClick={() => this.saveHeroImage('png')}    
                                      >
                                         <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                                      </a>
                                    </div>
                                    { isHeroPngImageUploading ?
                                    <div className="col-lg-2">
                                      <div className="center-row">                                         
                                          <Loader size={25} />
                                      </div>
                                    </div>:null
                                    }
                                   </>:
                                   <div>
                                      <img style={{maxWidth:"150px",maxHeight:"150px"}}
                                       src={ pageContent.location_hero_image_png && pageContent.location_hero_image_png.length > 0 ? pageContent.location_hero_image_png[0] :"" }
                                       alt=""
                                      />   
                                  </div>
                                   }
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      PNG Hero Image:
                                    </label>
                                    <div className="col-lg-6" style={{overflow : 'hidden'}}>
                                      { editInfo ?
                                     <input
                                        type="text"
                                        value={location_hero_image_png}
                                        name="location_hero_image_png"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        disabled
                                      /> :
                                      <span>
                                       {pageContent.location_hero_image_png &&  pageContent.location_hero_image_png.length > 0 ?  pageContent.location_hero_image_png[0]: ""}
                                      </span>
                                      }
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Hero Image Alt text:
                                    </label>
                                    {editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_hero_image_alt}
                                        name="location_hero_image_alt"
                                        onChange={this.changeVal}
                                        className="form-control m-input"                                
                                      />                                 
                                    </div>:
                                    <div className="col-lg-6">                               
                                      <span>
                                          {pageContent.location_hero_image_alt &&  pageContent.location_hero_image_alt.length > 0 ?  pageContent.location_hero_image_alt[0]: ""}
                                      </span>
                                    </div>
                                    }
                                  </div>

                              
                                </div>
                                : ""}
                              {step === 2 ?
                                <div className="m-form__section">
                                  <h1>Available Puppies Section</h1>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_all_puppies_title}
                                        name="location_all_puppies_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                             
                                    </div>:
                                      <div className="col-lg-6">
                                        <span>     
                                          {pageContent.location_all_puppies_title &&  pageContent.location_all_puppies_title.length > 0 ?  pageContent.location_all_puppies_title[0]: ""}
                                        </span>
                                      </div> 
                                    }

                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_all_puppies_description"
                                        onChange={this.changeVal}
                                        value={location_all_puppies_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_all_puppies_description &&  pageContent.location_all_puppies_description.length > 0 ?  pageContent.location_all_puppies_description[0]: ""}
                                      </span>
                                    </div> 
                                    }

                                  </div>
                          
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Transportation city text:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_all_puppies_transportation"
                                        onChange={this.changeVal}
                                        value={location_all_puppies_transportation}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_all_puppies_transportation &&  pageContent.location_all_puppies_transportation.length > 0 ?  pageContent.location_all_puppies_transportation[0]: ""}
                                      </span>
                                    </div> 
                                    }
                                  </div>
                                </div>
                                : ""}

                              {step === 3 ?
                                <div className="m-form__section">
                                  <h1>About The Quiz</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_quiz_title}
                                        name="location_quiz_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                             
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_quiz_title &&  pageContent.location_quiz_title.length > 0 ?  pageContent.location_quiz_title[0]: ""}
                                      </span>
                                    </div> 
                                    }
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_quiz_description"
                                        onChange={this.changeVal}
                                        value={location_quiz_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_quiz_description &&  pageContent.location_quiz_description.length > 0 ?  pageContent.location_quiz_description[0]: ""}
                                      </span>
                                    </div> 
                                    }
                                  </div>                        
                                </div>
                                : ""}

                              {step === 4 ?
                                <>
                                  <div className="m-form__section">
                                    <h1>Reviews</h1>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        Title:
                                      </label>
                                      { editInfo ?
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={location_review_title}
                                          name="location_review_title"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                        />                                     
                                      </div>:
                                      <div className="col-lg-6">
                                        <span>     
                                          {pageContent.location_review_title &&  pageContent.location_review_title.length > 0 ?  pageContent.location_review_title[0]: ""}
                                        </span>
                                      </div> 
                                     }
                                    </div>
                                    <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_review_description"
                                        onChange={this.changeVal}
                                        value={location_review_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:      
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_review_description &&  pageContent.location_review_description.length > 0 ?  pageContent.location_review_description[0]: ""}
                                      </span>
                                    </div> 

                                    }
                                    </div>                                     
                                  </div>                 
                                </>
                                : ""} 

                              {step === 5 ?
                                <div className="m-form__section">
                                  <h1>Puppy Financing</h1>                    
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_finance_title}
                                        name="location_finance_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                                 
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_finance_title &&  pageContent.location_finance_title.length > 0 ?  pageContent.location_finance_title[0]: ""}
                                      </span>
                                    </div> 
                                   }
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_finance_description"
                                        onChange={this.changeVal}
                                        value={location_finance_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_finance_description &&  pageContent.location_finance_description.length > 0 ?  pageContent.location_finance_description[0]: ""}
                                      </span>
                                     </div>
                                   }
                                  </div>
                                </div>
                                : ""}

                              {step === 6 ?
                                <div className="m-form__section">
                                  <h1>Puppy Delivery</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_delivery_title}
                                        name="location_delivery_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                                    
                                    </div>:
                                    <div className="col-lg-6">
                                     <span>     
                                        {pageContent.location_delivery_title &&  pageContent.location_delivery_title.length > 0 ?  pageContent.location_delivery_title[0]: ""}
                                      </span>
                                    </div>
                                   }
                                  </div>                   
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_delivery_description"
                                        onChange={this.changeVal}
                                        value={location_delivery_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_delivery_description &&  pageContent.location_delivery_description.length > 0 ?  pageContent.location_delivery_description[0]: ""}
                                     </span>
                                    </div>
                                    }
                                  </div>
                                </div>
                                : ""}

                             {step === 7 ?
                                <div className="m-form__section">
                                  <h1>Health Commitment</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_health_commitment_title}
                                        name="location_health_commitment_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                                   
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_health_commitment_title &&  pageContent.location_health_commitment_title.length > 0 ?  pageContent.location_health_commitment_title[0]: ""}
                                     </span>
                                    </div>
                                    } 

                                  </div>                        
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_health_commitment_description"
                                        onChange={this.changeVal}
                                        value={location_health_commitment_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                     <div className="col-lg-6">
                                        <span>     
                                          {pageContent.location_health_commitment_description &&  pageContent.location_health_commitment_description.length > 0 ?  pageContent.location_health_commitment_description[0]: ""}
                                        </span>
                                      </div>
                                     }
                                  </div>                               
                                 </div>
                                : ""}

                              {step === 8 ?
                                <div className="m-form__section">
                                  <h1>Core Team</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                       Title:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_core_team_title}
                                        name="location_core_team_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                               
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_core_team_title &&  pageContent.location_core_team_title.length > 0 ?  pageContent.location_core_team_title[0]: ""}
                                      </span>
                                    </div>
                                     }
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_core_team_description"
                                        onChange={this.changeVal}
                                        value={location_core_team_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_core_team_description &&  pageContent.location_core_team_description.length > 0 ?  pageContent.location_core_team_description[0]: ""}
                                      </span>
                                    </div>
                                     }

                                  </div>
                                </div>
                                : ""}

                              {step === 9 ?
                                <div className="m-form__section">
                                  <h1>Puppy Contact Us</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    { editInfo ?
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_contact_title}
                                        name="location_contact_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />                           
                                    </div>:
                                    <div className="col-lg-6">
                                      <span>     
                                        {pageContent.location_contact_title &&  pageContent.location_contact_title.length > 0 ?  pageContent.location_contact_title[0]: ""}
                                      </span>
                                    </div>
                                    }
                                  </div> 

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    {editInfo ?
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_contact_description"
                                        onChange={this.changeVal}
                                        value={location_contact_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>:
                                    <div className="col-lg-6">
                                     <span>     
                                       {pageContent.location_contact_description &&  pageContent.location_contact_description.length > 0 ?  pageContent.location_contact_description[0]: ""}
                                     </span>
                                    </div>
                                    }
                                  </div>                           
                                </div>
                                : ""}

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="m-portlet__foot">
                        <div className="row">
                          <div className="col-lg-12">
                            {this.state.loading == false ? (
                              <div
                                className="row"
                                style={{ justifyContent: "flex-end" }}
                              >
                                <div>
                                  {step > 1 ?
                                    <button
                                      type="button"
                                      onClick={e => this.goBack(this)}                               
                                      className="btn btn-secondary m-btn--pill mx-2 mt-2"
                                     >
                                      <span>
                                        <span>Back</span>
                                      </span>
                                    </button>
                                    : ""}
                                  {step === 9  ?
                                   editInfo &&
                                    <button
                                      type="button"
                                      onClick={this.locationUpdate}                                  
                                      className="btn btn-primary m-btn--pill mx-2 mt-2"
                                    >
                                      <span>
                                        &nbsp;&nbsp;
                                        <span>Update Page</span>
                                        &nbsp;&nbsp;                                      
                                      </span>
                                    </button>

                                    :
                                    <button
                                      type="button"
                                      onClick={e => this.goNext(this)}                                
                                      className="btn btn-secondary m-btn--pill mx-2 mt-2"
                                    >
                                      <span>
                                        <span>Next</span>
                                      </span>
                                    </button>
                                  }
                                </div>

                              </div>
                            ) : (
                              <div className="center-row">
                                <Loader size={50} />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state,
});

const mapDispatchToProps = dispatch => ({
  fetchSingleWooLocationPage: (id) => {
    dispatch(fetchSingleWooLocationPage(id));
  },
  uploadHeroImage: (data) => {
    dispatch(uploadHeroImage(data))
  },
  generateLocationPageContentBaseOnOpenAi : (data) => {
    dispatch(generateLocationPageContentBaseOnOpenAi(data));
  },
  updateWooLocationPage : (id, data) => {
    dispatch(updateWooLocationPage(id, data))
  }


});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Datamodal)
);